import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material/styles';
import AnswersCard from '../molecules/AnswersCard';
import EmptyState from '../molecules/Emptystate';
import emptyImage from '../../assets/talking-people.svg';
import { GqlTalentPhaseNote } from '@bloomays-lib/types.shared';

type JobTalentNotesProps = {
  notes: GqlTalentPhaseNote[];
};

const JobTalentNotes = ({ notes }: JobTalentNotesProps) => {
  const { t } = useTranslation('talentBoard');

  return (
    <ProfileTab>
      {notes.length === 0 && (
        <EmptyStateContainer>
          <EmptyState image={emptyImage} text={t('talentJob.emptyProfile')} />
        </EmptyStateContainer>
      )}
      {notes.length > 0 &&
        notes.map((note) => (
          <AnswersCard
            key={note.id}
            title={note.phaseId}
            answers={Object.entries(note.answers).map(([question, answer]) => ({
              question,
              answer,
            }))}
          />
        ))}
    </ProfileTab>
  ) as React.ReactNode;
};

const ProfileTab = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
  [theme.breakpoints.down('md')]: {
    backgroundColor: theme.palette.neutral.white,
    gap: '0px',
  },
}));

const EmptyStateContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  marginTop: '160px',
  [theme.breakpoints.down('md')]: {
    marginTop: '60px',
  },
}));

export { JobTalentNotes };
export default JobTalentNotes;
